export const selectBanners = (state) => state.content.banners;
export const selectWebBanners = (state) => state.content.webBanners;
export const selectTitles = (state) => state.content.titles;
export const selectContacts = (state) => state.content.contacts;
export const selectContentLoading = (state) => state.content.loading;
export const selectContentError = (state) => state.content.error;
export const selectContentSuccess = (state) => state.content.success;